import { Session } from 'next-auth';

import { CRMUserType } from '@web/services/crm-api/token';

export function isUserType(session: Session, type: CRMUserType): boolean {
	return (session?.user?.userTypes || []).includes(type);
}
